import { useEffect } from 'react'

/**
 * Locks page scroll while `active`. The lock sits on <html> — the viewport is
 * the page's only scroll container, so locking <body> does nothing.
 *
 * Counted rather than save/restore: a sheet holds its lock through the close
 * animation, so two overlays can overlap, and restoring a saved value out of
 * order would leave the page stuck unscrollable.
 */
let holders = 0

export const usePageScrollLock = (active: boolean) => {
  useEffect(() => {
    if (!active) return undefined
    holders += 1
    document.documentElement.style.overflow = 'hidden'
    return () => {
      holders -= 1
      if (holders === 0) document.documentElement.style.overflow = ''
    }
  }, [active])
}
